"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeZoneOptions = void 0;
var moment = require("moment-timezone");
exports.getTimeZoneOptions = function (showTimezoneOffset) {
    var timeZones = moment.tz.names();
    var offsetTmz = [];
    for (var i in timeZones) {
        var tz = timeZones[i];
        var tzOffset = moment.tz(tz).format('Z');
        var value = parseInt(tzOffset
            .replace(':00', '.00')
            .replace(':15', '.25')
            .replace(':30', '.50')
            .replace(':45', '.75')).toFixed(2);
        var timeZoneOption = {
            label: showTimezoneOffset ? tz + " (GMT" + tzOffset + ")" : tz,
            value: value
        };
        offsetTmz.push(timeZoneOption);
    }
    return offsetTmz;
};
//# sourceMappingURL=Timezones.js.map